/**
 *https://znlh-work.feishu.cn/wiki/wikcnYetNccP3VGROfLlkDFbphh
 *需求如上 登录错误的封装
 */
class ErrorLogin {
  constructor() {
    if (typeof ErrorLogin.instance === 'object') {
      return ErrorLogin.instance;
    }
    ErrorLogin.instance = this;
    this.init();
  }

  // errorLogin: {
  //     errorPhone: 0,
  //     errorName: 0
  // }
  /**
   * 初始化缓存数据 如果当前不存在
   * @return
   */
  // eslint-disable-next-line class-methods-use-this
  init = () => {
    if (!localStorage.getItem('errorLogin')) {
      localStorage.setItem('errorLogin', JSON.stringify({
        errorPhone: 0,
        errorName: 0,
      }));
    }
    this.errorLogin = JSON.parse(localStorage.getItem('errorLogin'));
  }

  /**
   * @function 刷新验证码状态为初始值
   * @return void
   */
  refreshCode = () => {
    this.errorLogin.errorPhone = 0;
    localStorage.setItem('errorLogin', JSON.stringify(this.errorLogin));
  }

  /**
   * @function 刷新密码登录状态状态为初始值
   * @return void
   */
  // eslint-disable-next-line consistent-return
  refreshPasWord = (type) => {
    // eslint-disable-next-line no-unused-expressions
    type === 0 ? this.errorLogin.errorPhone = 0 : this.errorLogin.errorName = 2;
    localStorage.setItem('errorLogin', JSON.stringify(this.errorLogin));
  }

  /**
   * @function 增加验证码登录错误次数
   * @return void
   */
  addErrorPhone = () => {
    this.errorLogin.errorPhone += 1;
    localStorage.setItem('errorLogin', JSON.stringify(this.errorLogin));
  }

  /**
   * @function 增加密码登录错误次数 （域账号和用户名登录 业务场景只会存在一种）
   * @return void
   */
  addErrorName = () => {
    this.errorLogin.errorName += 1;
    localStorage.setItem('errorLogin', JSON.stringify(this.errorLogin));
  }

  /**
   * @function 获取验证码前校验是否超过指定错误次数
   * @param {String} name 用户名/手机号
   * @return {bool} false- 进行图形码验证
   */
  voidCodeLogin = (type) => {
    if (type === 0 && this.errorLogin.errorPhone >= 1) {
      return false;
    }
    if (type === 1 && this.errorLogin.errorName >= 3) {
      return false;
    }
    return true;
  }
}

export default ErrorLogin;
